// import Image from "next/image";
import Link from "next/link";
import React from "react";

interface Props {
  data?: any;
}

const BlogBanner: React.FC<Props> = ({ data }) => {
  return (
    <section className="blog-banner overflow-hidden bg-background-dark pt-[121px] md:pt-[155px] xl:pt-[175px] pb-[56px] md:pb-[80px] xl:pb-[100px] relative z-0">
      {/* Shapes */}
      {/* <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
        <Image
          src="/images/banner-left-layer-mobile.png"
          alt="Banner Shape"
          width={571}
          height={571}
          className="w-full h-full md:hidden"
        />
        <Image
          src="/images/banner-left-layer-tablet.png"
          alt="Banner Shape"
          width={571}
          height={571}
          className="w-full h-full hidden md:block lg:hidden"
        />
        <Image
          src="/images/banner-left-layer-desktop.png"
          alt="Banner Shape"
          width={571}
          height={571}
          className="w-full h-full hidden lg:block"
        />
      </div>
      <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
        <Image
          src="/images/banner-right-layer-mobile.png"
          alt="Banner Shape"
          width={471}
          height={471}
          className="object-cover w-full h-full md:hidden"
        />
        <Image
          src="/images/banner-right-layer-tablet.png"
          alt="Banner Shape"
          width={471}
          height={471}
          className="object-cover w-full h-full hidden md:block lg:hidden"
        />
        <Image
          src="/images/banner-right-layer-desktop.png"
          alt="Banner Shape"
          width={471}
          height={471}
          className="object-cover w-full h-full hidden lg:block"
        />
      </div> */}

      <div className="container">
        <Link
          href="/blog"
          className="text-[#83858C] font-[400] xl:text-[16px] xl:leading-[22.4px] text-[14px] leading-[19.6px] tracking-[1px] md:mb-[32px] mb-[16px] block text-center uppercase"
        >
          Insights / <span className="text-white">Blog</span>
        </Link>

        <div className="blog-heading mb-0">
          <h1 className="text-center text-white font-[800] xl:text-[64px] xl:leading-[83.2px] lg:text-[56px] lg:leading-[72.8px] text-[36px] leading-[46.8px] mb-[12px]">
            {data?.title ??
              "Insights Shaping the Future of Enterprise Technology"}
          </h1>

          <p className="text-secondary-text-white text-center font-regular xl:text-[18px] xl:leading-[25.5px] lg:text-[16px] lg:leading-[22.4px] text-[14px] lg:leading-[19.6px] max-w-[900px] mx-auto">
            {data?.description ??
              "Cut through the noise of trending tech. Discover clear, expert-driven insights that help you identify what works, what matters, and what delivers real value for your enterprise."}
          </p>
        </div>
      </div>
    </section>
  );
};

export default BlogBanner;
